/**
 * MKTSYNC-1 · C · 「内容营销」模块左侧二级细栏（仅订阅版 + 顶部导航版式；MKT-1 偏差 9）。
 * 样稿：designs/mockups/theme/个人站订阅版-样稿.html 画面 ④ 左栏（tag saas-mockup-v1）：社媒概览 / 帖子列表 / 产品开放 / 分组「S4」·「进入 S4 控制台 ↗」。
 * 做法同 SAAS-2「今日」细栏（chrome/TodaySubnav.tsx）：样式一致；点一项 = 切内容营销页的对应页签（?tab=），和页内页签同一个地址参数。
 * 「进入 S4 控制台」与页面右上角按钮同一个动作（openS4Console，一次性免登录链接），同一套显隐条件（有 marketing.s4.enter 权限且 S4 已配置）。
 * 本目录整体不进公司站导出。
 */
import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { cn } from "@/lib/utils";
import { useCan } from "@/auth/permissions";
import { openS4Console, useMarketingStatus } from "./api";

const item = "flex items-center justify-between rounded-md px-2.5 py-1.5 text-[13px] text-slate-600 hover:bg-slate-50";
const on = "bg-brand-soft font-semibold text-brand";
const TABS = [
  { tab: null, label: "社媒概览" },
  { tab: "posts", label: "帖子列表" },
  { tab: "products", label: "产品开放" },
] as const;

export function MarketingSubnav() {
  const loc = useLocation();
  const st = useMarketingStatus();
  const canEnter = useCan("marketing.s4.enter");
  const [entering, setEntering] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const cur = new URLSearchParams(loc.search).get("tab");
  const active = (t: string | null) => loc.pathname === "/marketing" && (t === null ? cur !== "posts" && cur !== "products" : cur === t);
  const enter = async () => {
    setEntering(true);
    setErr(await openS4Console());
    setEntering(false);
  };

  return (
    <nav className="hidden w-44 shrink-0 flex-col gap-0.5 border-r border-slate-200 bg-white p-2 md:flex" data-testid="marketing-subnav" aria-label="内容营销">
      {TABS.map((t) => (
        <NavLink key={t.label} to={t.tab ? `/marketing?tab=${t.tab}` : "/marketing"} className={cn(item, active(t.tab) && on)} data-testid={`mkt-sub-${t.tab ?? "overview"}`}>
          {t.label}
        </NavLink>
      ))}
      {canEnter && st.data?.s4_configured && (
        <>
          <div className="px-2.5 pb-0.5 pt-2.5 text-[11px] text-slate-400">S4</div>
          <button type="button" onClick={enter} disabled={entering} className={cn(item, "text-left disabled:opacity-60")} data-testid="mkt-sub-enter">
            <span>进入 S4 控制台</span>
            <ExternalLink size={12} />
          </button>
          {err && <p className="px-2.5 text-[11.5px] text-rose-600" role="alert">{err}</p>}
        </>
      )}
    </nav>
  );
}
